import { __rest } from '../node_modules/tslib/tslib.es6.mjs.js';
import React__default from 'react';
import classNames from 'classnames';
import { applyTheme } from '../Theme/Theme.js';

const Text = (_a) => {
    var { theme, richText, noUnderline, tag = 'p', type, className = '', style = {}, children, truncateLineSize } = _a, rest = __rest(_a, ["theme", "richText", "noUnderline", "tag", "type", "className", "style", "children", "truncateLineSize"]);
    const Tag = tag;
    const fontStyle = `xps-text-${type}`;
    if (!richText && tag === 'div') {
        console.error('div tag can only use with richText');
    }
    const updatedStyle = Object.assign({ '--xps-text--truncate-line-size': truncateLineSize }, style);
    if (richText) {
        const RichTextTag = tag === 'p' ? 'div' : tag;
        return (React__default.createElement(RichTextTag, Object.assign({ dangerouslySetInnerHTML: { __html: richText }, className: classNames('xps-text', applyTheme(theme), { [fontStyle]: type }, className, { 'no-underline ': noUnderline }, { 'xps-text--color': theme }), style: style }, rest)));
    }
    return (React__default.createElement(Tag, Object.assign({ className: classNames('xps-text', applyTheme(theme), { [fontStyle]: type }, className, { 'xps-text--color': theme, 'truncate-text': !!truncateLineSize }), style: updatedStyle }, rest), children));
};

export { Text };
//# sourceMappingURL=Text.js.map
